import { DayPicker } from "react-day-picker";
import { es } from "react-day-picker/locale";
import "react-day-picker/style.css";

import Popover from "componentsv2/widgets/Popover";

function Calendar({
  name,
  selected,
  onSelect,
  mode,
  show,
  month,
  containerClass,
  containerStyle,
}) {
  function setDate(value) {
    onSelect(value, name);
    show.value = false;
  }

  return (
    <Popover
      key={name}
      name={name}
      show={show}
      classNameContainer={containerClass}
      style={containerStyle}
    >
      <DayPicker
        locale={es}
        animate
        month={month}
        captionLayout="dropdown"
        mode={mode || "single"}
        selected={selected}
        onSelect={setDate}
        endMonth={new Date(2027, 12)}
      />
      <button
        type="button"
        className="text-red-800 rounded-md pr-2 relative w-full text-right"
        onClick={() => (show.value = false)}
      >
        Cerrar
      </button>
    </Popover>
  );
}

export default Calendar;
